import FirebaseService from './FirebaseService';

class ChatRoomService extends FirebaseService {
    // Get a reference to a specific chat room
    static __roomReference(chatRoomId) {
        /* chatRooms/{UUID} */
        return this.safeExecute(() => this.__reference(`chatRooms/${chatRoomId}`));
    }

    // Get a reference to chat room members or a specific member
    static __membersReference(chatRoomId, memberId = null) {
        /* chatRooms/{UUID}/members/{memberId} */
        const referencePath = memberId ? `members/${memberId}` : 'members';
        return this.__roomReference(chatRoomId).child(referencePath);
    }

    // Get a particular member based on id
    static async __getMemberDetail(chatRoomId, id) {
        return this.safeExecuteAsync(async () => {
            const memberRef = await this.__membersReference(chatRoomId,id).once('value');
            return memberRef.exists() ? memberRef.val() : null;
        });
    }
}

export default ChatRoomService;